module.exports = __webpack_public_path__ + "static/media/testimonal16.bcdc418e.webp";